import { GetDirectoratesResponse, GetMeclisUyeleriResponse, GetMuhtarlarResponse, GetVicePresidentsResponse, ManagerList } from "../models/Response/PortalPeople";
import api from "./axiosInstance";
import { ApiBaseResponse } from "../models/Common/ApiBaseResponse";

const API_URL = "/PortalPeople";

const PortalPeopleApi = {
    getVicePresidents: async (): Promise<ApiBaseResponse<GetVicePresidentsResponse> | null> => {
        try {
            const response = await api.get<ApiBaseResponse<GetVicePresidentsResponse>>(`${API_URL}/GetVicePresidents`);
            return response.data;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }
    },
    getMuhtarlar: async (): Promise<ApiBaseResponse<GetMuhtarlarResponse> | null> => {
        try {
            const response = await api.get<ApiBaseResponse<GetMuhtarlarResponse>>(`${API_URL}/GetMuhtarlar`);
            return response.data;
        } catch (error) {
            console.error("Error:", error);
            return null;
        }
    },
    getMeclisUyeleri: async (): Promise<GetMeclisUyeleriResponse | null> => {
        try {
            const response = await api.get<{ content: GetMeclisUyeleriResponse }>(`${API_URL}/GetMeclisUyeleri`);
            return response.data.content;
        } catch (error) {
            console.error("Error getDashboardData:", error);
            return null;
        }
    },
    getMudurlukler: async (): Promise<GetDirectoratesResponse | null> => {
        try {
            const response = await api.get<{ content: GetDirectoratesResponse }>(`${API_URL}/GetDirectorates`);
            return response.data.content;
        } catch (error) {
            console.error("Error getDashboardData:", error);
            return null;
        }
    },
    getMudurlukDetay: async (id: number): Promise<ManagerList | null> => {
        try {
            const response = await api.get<{ content: ManagerList }>(`${API_URL}/GetDirectorates/${id}`);
            return response.data.content;
        } catch (error) {
            console.error("Error getDashboardData:", error);
            return null;
        }
    },
};

export default PortalPeopleApi;
